import Layout from "../components/Layout/HomePage/Layout"
import TestScreen from "../components/Rowpage/TestScreen"

export default function RowPage(){
    return(
        <Layout>            
           <TestScreen />
        </Layout>
    )
}